export default __webpack_public_path__ + "static/media/wizard-complete.2c585539.svg";